import { defaultApiState } from '../api.state';

export const userManagementState = {
  apiState: {
    getAdmins: defaultApiState,
    getAdmin: defaultApiState,
    addAdmin: defaultApiState,
    updateAdmin: defaultApiState,
    deleteAdmin: defaultApiState,
    updateAdminPassword: defaultApiState,
    getUsers: defaultApiState,
    getUser: defaultApiState,
    getUserTransactions: defaultApiState,
    getUserSubscriptions: defaultApiState,
    updateUser: defaultApiState,
  },
  admins: [],
  admin: undefined,
  users: [],
  user: undefined,
  transactions: [],
  subscriptions: [],
};
